import { componentCls } from "@faire/slate/lib/tracking";
import { ToggleBase } from "@faire/slate/private/toggle/ToggleBase";
import { IToggleWebProps } from "@faire/slate/private/toggle/types";
import React from "react";

type IProps = {
  /**
   * Whether the toggle is checked.
   *
   * @default false
   */
  checked?: boolean;
  /**
   * Whether the toggle is disabled.
   *
   * @default false
   */
  disabled?: boolean;

  // DO NOT ADD any new prop without aligning with Slate team first
} & IToggleWebProps;

/**
 * Toggles enable users to switch a single option on or off.
 *
 * {@link https://www.notion.so/faire/Toggle-2242efb5c25a80818394c7c8f248ff8a | Slate/Toggle}
 */
export const Toggle: React.FC<IProps> = (props) => (
  <ToggleBase
    {...props}
    className={componentCls()}
    data-component-name="Slate/Toggle"
  />
);
